import React from "react";
import { reduxForm } from "redux-form";
import { CircularProgress } from "@mui/material";
import styles from "../pre-start/JobSwmsFormV3PreStart.module.css";

function JobSwmsV3RescueReadinessContainer({ serverState = {}, onRetry, included = true, toggle = true }) {
  const items = Array.isArray(serverState.data) ? serverState.data : [];
  const error = serverState.error;
  const isIncluded = included && toggle;

  return (
    <div className={styles.PreStartContainer}>
      <div className={styles.PreStartHeaderRow}>
        <div>
          <div className={styles.PreStartTitle}>Emergency Readiness</div>
          <div className={styles.PreStartSubtitle}>Manage the emergency readiness questions for this SWMS.</div>
        </div>
      </div>
      <div className={styles.PreStartHeadingWrap}>
        {!isIncluded ? <div className={styles.PreStartExcludedState}>Excluded from this SWMS</div> : null}
        {serverState.loading ? <div className={styles.PreStartLoadingState}><CircularProgress size={18} /></div> : null}
        {!serverState.loading && error ? <div className={styles.PreStartErrorState}><div>{error}</div><button type="button" className={styles.PreStartRetryButton} onClick={onRetry}>Retry</button></div> : null}
        {!serverState.loading && !error && items.length === 0 ? <div className={styles.PreStartEmptyState}>No emergency readiness questions yet.</div> : null}
        {!serverState.loading && !error && items.length > 0 ? <div className={styles.PreStartPlaceholderList}>{items.map((item, index) => <div className={styles.PreStartPlaceholderItem} key={item.id || index}>{item.question_text || item.question || "Emergency readiness question"}</div>)}</div> : null}
      </div>
    </div>
  );
}

export default reduxForm({ form: "JobSwmsV3RescueReadinessContainerForm", destroyOnUnmount: true, enableReinitialize: true })(JobSwmsV3RescueReadinessContainer);
